(() => {
  'use strict';
  if (window.ucwPrinterFinderInitialized) return;
  window.ucwPrinterFinderInitialized = true;
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root) || !window.UCWPrinterCatalog) return;
    const selectionMode = root.dataset.finderMode === 'select';
    const copy=(key,fallback,args)=>selectionMode&&typeof root.ucwSupportText==='function'?root.ucwSupportText('finder.'+key,args):fallback;
    const { create, normalize, compare } = window.UCWPrinterCatalog;
    const el = key => root.querySelector(`[data-finder-${key}]`), lifecycle = new AbortController();
    const signal = lifecycle.signal, models = el('models'), query = el('model-search'), series = el('series');
    let store = window.UCWPrinters;
    let catalog, state = { items: [], status: 'idle' }, limit = 36, generation = 0, metadata, selected, frame = 0;
    let hpAnswer = '', activeStep = 'brand', currentBrand = null, matchCount = 0;
    let previousStep;
    if(selectionMode){previousStep=document.createElement('button');previousStep.type='button';previousStep.className='ucw-support__back';previousStep.textContent=copy('back','Vorige stap');previousStep.hidden=true;root.append(previousStep);previousStep.addEventListener('click',()=>root.querySelector('[data-finder-progress="'+(activeStep==='confirm'?'model':'brand')+'"]').click(),{signal});}
    const batchSize = 36, sentinel = el('sentinel'), helpDialog = el('help-dialog'), helpImage = el('help-image');
    const helpImageAlt = helpImage.alt;
    let helpTrigger = null, previousOverflow = '', scrollFrame = 0;
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) loadMore();
    }, { rootMargin: '320px 0px' }) : null;
    observer?.observe(sentinel);
    function loadMore() {
      if (activeStep !== 'model' || root.hidden || matchCount <= limit) return;
      limit = Math.min(limit + batchSize, matchCount); render();
    }
    function closeHelp() { if (helpDialog.open) helpDialog.close(); }
    function openHelp(trigger) {
      if (helpDialog.open) return;
      helpTrigger = trigger; helpImage.hidden = true; helpImage.removeAttribute('src');
      const image = currentBrand?.helpImage;
      if (image) {
        try {
          const url = new URL(image, location.origin);
          if (url.protocol === 'https:') {
            helpImage.alt = `${currentBrand.name} — ${helpImageAlt}`;
            helpImage.onload = () => { helpImage.hidden = false; };
            helpImage.onerror = () => { helpImage.hidden = true; };
            helpImage.src = url.href;
          }
        } catch {}
      }
      previousOverflow = document.documentElement.style.overflow;
      helpDialog.showModal(); document.documentElement.style.overflow = 'hidden';
    }
    helpDialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      if (helpTrigger?.isConnected) helpTrigger.focus({ preventScroll: true });
      helpTrigger = null;
    }, { signal });
    helpDialog.addEventListener('click', event => {
      if (event.target !== helpDialog) return;
      const box = helpDialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeHelp();
    }, { signal });
    const handleOf = item => decodeURIComponent(item.url.split('/').pop());
    const canContinue = () => Boolean(selected && (selectionMode || !selected.hpPlus || hpAnswer === 'no'));
    function renderAccount() {
      store = window.UCWPrinters;
      if (root.hasAttribute('data-finder-home-empty')) {
        const account = store?.snapshot();
        const hasPrinters = account?.status === 'ready' && account.printers.length > 0;
        const hidden = account?.status === 'loading' || hasPrinters;
        root.hidden = hidden;
        const wrapper = root.closest('.shopify-section'); if (wrapper) wrapper.hidden = hidden;
      }
      renderActions();
    }
    function renderActions() {
      store = window.UCWPrinters;
      if (!selected) return;
      const allowed = canContinue();
      el('hp').hidden = selectionMode || !selected.hpPlus;
      el('hp-help').hidden = !['yes', 'unknown'].includes(hpAnswer);
      root.querySelectorAll('[data-finder-hp-answer]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.finderHpAnswer === hpAnswer)));
      el('hp-message').textContent = hpAnswer === 'yes' ? root.dataset.hpYes : hpAnswer === 'unknown' ? root.dataset.hpUnknown : hpAnswer === 'no' ? root.dataset.hpNo : 'Kies uw antwoord voordat u verdergaat.';
      el('hp-message').dataset.answer = hpAnswer;
      el('hp').dataset.answer = hpAnswer;
      el('confirm').hidden = !allowed;
      if (allowed) el('confirm').href = selectionMode ? '#' : selected.url; else el('confirm').removeAttribute('href');
      const productLabel = selected.productType === 'cartridge' ? 'cartridges' : selected.productType === 'toner' ? 'toners' : 'producten';
      el('confirm').textContent = selectionMode ? copy('confirm_yes','Ja, dit is mijn printer') : `Ja, toon de geschikte ${productLabel} →`;
      el('confirm').classList.add('is-saved-printer');
    }
    function step(name) {
      closeHelp(); activeStep = name;
      if(previousStep)previousStep.hidden=name==='brand';
      root.querySelectorAll('[data-finder-step]').forEach(panel => { panel.hidden = panel.dataset.finderStep !== name; });
      root.querySelectorAll('[data-finder-progress]').forEach(item => {
        const target = item.dataset.finderProgress;
        item.disabled = target === name || target === 'model' && !currentBrand || target === 'confirm' && !selected;
        if (item.dataset.finderProgress === name) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
      });
    }
    function render() {
      frame = 0;
      el('filters').hidden = state.items.length < 30;
      const example = currentBrand?.example || state.items[0]?.name;
      query.placeholder = example ? root.dataset.exampleLabel.replace('__model__', example) : root.dataset.placeholderDefault;
      const focusedModel = models.contains(document.activeElement) ? document.activeElement.closest('[data-model-url]')?.dataset.modelUrl : '';
      const currentSeries = series.value;
      const seriesNames = [...new Set(state.items.map(item => item.series).filter(Boolean))].sort(compare);
      series.replaceChildren(new Option(copy('all_series','Alle series'), ''), ...seriesNames.map(name => new Option(name, name)));
      series.value = seriesNames.includes(currentSeries) ? currentSeries : '';
      const needle = normalize(query.value);
      const matches = state.items.filter(item => (!series.value || item.series === series.value) && (!needle || item.search.includes(needle))).sort((a, b) => compare(a.name, b.name));
      matchCount = matches.length;
      const existing = new Map([...models.children].map(li => [li.querySelector('[data-model-url]').dataset.modelUrl, li]));
      const visible = matches.slice(0, limit);
      const wanted = new Set(visible.map(item => item.url));
      for (const [url, li] of existing) if (!wanted.has(url)) li.remove();
      visible.forEach((item, index) => {
        let li = existing.get(item.url);
        if (!li) {
          li = document.createElement('li');
          const button = document.createElement('button'); button.type = 'button'; button.dataset.modelUrl = item.url;
          const title = document.createElement('span'); title.textContent = item.name;
          const arrow = document.createElement('span'); arrow.textContent = '›'; arrow.setAttribute('aria-hidden', 'true');
          button.append(title, arrow); li.append(button);
        } else {
          const title = li.querySelector('button span');
          if (title.textContent !== item.name) title.textContent = item.name;
        }
        if (models.children[index] !== li) models.insertBefore(li, models.children[index] || null);
      });
      if (focusedModel) [...models.querySelectorAll('[data-model-url]')].find(button => button.dataset.modelUrl === focusedModel)?.focus({ preventScroll: true });
      el('more').hidden = Boolean(observer) || matchCount <= limit;
      sentinel.hidden = !observer || matchCount <= limit;
      cancelAnimationFrame(scrollFrame);
      if (observer && activeStep === 'model' && matchCount > limit) scrollFrame = requestAnimationFrame(() => {
        if (!sentinel.getClientRects().length) return;
        const bounds = sentinel.getBoundingClientRect();
        if (bounds.top <= window.innerHeight + 320 && bounds.bottom >= 0) loadMore();
      });
      const count = copy(matches.length===1?'count_one':'count_many', `${matches.length} ${matches.length === 1 ? 'model' : 'modellen'} gevonden.`,{count:matches.length});
      el('status').textContent = state.status === 'error' ? copy('incomplete',`${count} De lijst is nog niet volledig. Probeer verder laden.`,{count}) : state.status === 'complete' ? (matches.length ? count : copy('empty','Geen model gevonden. Controleer het merk en het volledige typenummer.')) : copy('more_loading',`${count} Meer modellen worden geladen…`,{count});
      el('retry').hidden = state.status !== 'error';
    }
    function resetSelection() { selected = null; hpAnswer = ''; metadata?.abort(); el('confirm').removeAttribute('href'); el('image').hidden = true;  }
    function chooseBrand(button, focus = true) {
      generation++; catalog?.dispose(); resetSelection(); cancelAnimationFrame(frame); frame = 0;
      state = { items: [], status: 'loading' }; query.value = ''; series.replaceChildren(new Option(copy('all_series','Alle series'), '')); limit = batchSize; matchCount = 0;
      currentBrand = { name: button.dataset.brandName, example: button.dataset.brandExample || '', helpImage: button.dataset.brandHelpImage || '', logo: button.querySelector?.('.ucw-finder__brand-image')?.getAttribute('src') || '' };
      root.querySelector('.ucw-finder__title').textContent = (root.dataset.headingBrand || 'Vind de juiste cartridges voor uw __brand__ printer').replace('__brand__', currentBrand.name);
      query.placeholder = currentBrand.example ? root.dataset.exampleLabel.replace('__model__', currentBrand.example) : root.dataset.placeholderDefault;
      models.replaceChildren(); el('status').textContent = copy('loading','Printermodellen worden geladen…'); el('more').hidden = true; sentinel.hidden = true; el('retry').hidden = true;
      el('filters').hidden = true;
      el('brand-title').textContent = copy('title',`Welk model ${button.dataset.brandName} heeft u?`,{brand:button.dataset.brandName}); step('model'); if (focus) el('brand-title').focus();
      const epoch = generation;
      catalog = create(button.dataset.brandUrl, next => {
        if (epoch !== generation) return; state = next; if (!frame) frame = requestAnimationFrame(render);
      });
      catalog.start();
    }
    function showPrinterImage(item, raw, fallback = '') {
      const img = el('image'); img.hidden = true;
      if (!raw || selected !== item) return;
      let url; try { url = new URL(raw, location.origin); } catch { return; }
      if (url.protocol !== 'https:') return;
      img.alt = item.name;
      img.classList.remove('is-brand-logo');
      img.onload = () => { if (selected === item) img.hidden = false; };
      img.onerror = () => { img.hidden = true; if (fallback && selected === item) showPrinterImage(item, fallback); };
      img.src = url.href;
    }
    async function chooseModel(url) {
      const item = state.items.find(entry => entry.url === url); if (!item) return;
      resetSelection(); selected = item; el('name').textContent = item.name; renderActions(); step('confirm'); el('confirm-title').focus();
      const controller = new AbortController(); metadata = controller;
      const timer = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(`${item.url}?view=ucw-meta`, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) return; const data = await response.json();
        if (selected !== item || controller.signal.aborted || data.handle !== decodeURIComponent(item.url.split('/').pop())) return;
        if (data.title) el('name').textContent = data.title;
        showPrinterImage(item, data.featured_image || data.placeholder_image, data.featured_image ? data.placeholder_image : '');
      } catch {} finally { clearTimeout(timer); }
    }
    el('brand-search').addEventListener('input', () => {
      const needle = normalize(el('brand-search').value); let count = 0;
      root.querySelectorAll('[data-finder-brand]').forEach(button => { button.closest('li').hidden = !normalize(button.dataset.brandName).includes(needle); if (!button.closest('li').hidden) count++; });
      el('brand-empty').hidden = count > 0;
    }, { signal });
    root.addEventListener('click', event => {
      const brand = event.target.closest('[data-finder-brand]'), model = event.target.closest('[data-model-url]');
      if (brand) chooseBrand(brand); if (model) chooseModel(model.dataset.modelUrl);
      const progress = event.target.closest('[data-finder-progress]');
      if (progress && !progress.disabled) {
        const target = progress.dataset.finderProgress;
        if (target === 'brand') {
          generation++; catalog?.dispose(); catalog = null; cancelAnimationFrame(frame); frame = 0;
          resetSelection(); currentBrand = null; root.querySelector('.ucw-finder__title').textContent = root.dataset.headingDefault || 'Vind de juiste cartridges voor uw printer'; step('brand'); el('brand-search').focus();
        } else if (target === 'model' && currentBrand) {
          resetSelection(); step('model'); query.focus();
        }
      }
      const info = event.target.closest('[data-finder-help-open]'); if (info) openHelp(info);
      if (event.target.closest('[data-finder-help-close]')) closeHelp();
      const hp = event.target.closest('[data-finder-hp-answer]');
      if (hp && selected?.hpPlus) { hpAnswer = hp.dataset.finderHpAnswer; renderActions(); }
    }, { signal });
    el('confirm').addEventListener('click', event => {
      if (!canContinue() || selectionMode) event.preventDefault();
      if (selectionMode && canContinue()) root.dispatchEvent(new CustomEvent('ucw:printer-selected', { bubbles:true, detail:{ handle:handleOf(selected), name:selected.name, productType:selected.productType } }));
    }, { signal });
    document.addEventListener('ucw:printers-updated', renderAccount, { signal });
    store?.ready?.then(renderAccount);
    renderAccount();
    for (const control of [query, series]) control.addEventListener(control === query ? 'input' : 'change', () => { limit = batchSize; render(); }, { signal });
    el('more').addEventListener('click', loadMore, { signal });
    el('retry').addEventListener('click', () => catalog?.start(), { signal });
    instances.set(root, () => { generation++; catalog?.dispose(); metadata?.abort(); observer?.disconnect(); if (helpDialog.open) { closeHelp(); document.documentElement.style.overflow = previousOverflow; } lifecycle.abort(); previousStep?.remove(); cancelAnimationFrame(frame); cancelAnimationFrame(scrollFrame); instances.delete(root); });
    if (root.dataset.initialBrandUrl && root.dataset.initialBrandName) chooseBrand([...root.querySelectorAll('[data-finder-brand]')].find(button => button.dataset.brandUrl === root.dataset.initialBrandUrl) || { dataset: { brandUrl: root.dataset.initialBrandUrl, brandName: root.dataset.initialBrandName } }, false);
  }
  window.UCWPrinterFinder = Object.freeze({ mount:init, destroy:root => instances.get(root)?.() });
  const scan = (scope = document) => scope.querySelectorAll('[data-ucw-printer-finder]').forEach(init);
  scan(); document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ucw-printer-finder]').forEach(root => instances.get(root)?.()));
})();





